import React, { useEffect } from "react";
import Softwareabout from "./Softwareabout";
import Softwaresevices from "./Softwaresevices";
import Bankingexplore from "./Bankingexplore";
import Softwaresolutions from "./Softwaresolutions";
import Softwarebanner from "./Softwarebanner";

const Software= () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        backgroundImage:
          "url('/image/3662a43d-artificial-intelligence.jpeg.optimal.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
        <Softwarebanner/>
        <Softwareabout/>
        <Softwaresevices/>

        {/* <Bankingexplore/> */}
        <Softwaresolutions/>
      </div>
    </div>
  );
};

export default Software;
